import { Box, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React, { FC } from 'react'
import MuiCircularProgress from '@material-ui/core/CircularProgress'
import CheckIcon from '@material-ui/icons/Check'
import PriorityHighIcon from '@material-ui/icons/PriorityHigh'
import { green, red, grey } from '@material-ui/core/colors'
import { useTranslation } from 'react-i18next'
import { TwoFaMobileProgressStatus } from '../../graphql'

const useStyles = makeStyles((theme: Theme) => ({
  twoFaProgressWrapper: {
    margin: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  twoFaProgressWrapper2: {
    position: 'relative',
  },
  twoFaProgress: {},
  twoFaIconCheck: {
    width: 60,
    height: 60,
    position: 'absolute',
    zIndex: 2,
    top: 10,
    left: 10,
  },
  twoFaIconError: {
    width: 50,
    height: 50,
    position: 'absolute',
    zIndex: 2,
    top: 15,
    left: 14,
  },
}))

const getColor = (status: TwoFaMobileProgressStatus) =>
  ({
    pending: grey[500],
    success: green[500],
    error: red[500],
  }[status])

const getMessage = (
  t: (key: string, defaultValue?: string) => string,
  status: TwoFaMobileProgressStatus,
) =>
  ({
    pending: '',
    success: t('twoFaMobileConfirmed', 'Confirmed'),
    error: t('twoFaMobileError', 'An error has occured, please try again'),
  }[status])

export const CircularProgress: FC<{
  status: TwoFaMobileProgressStatus
}> = ({ status }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <Box className={classes.twoFaProgressWrapper}>
        <Box className={classes.twoFaProgressWrapper2}>
          {status === TwoFaMobileProgressStatus.Success && (
            <CheckIcon className={classes.twoFaIconCheck} style={{ color: getColor(status) }} />
          )}
          {status === TwoFaMobileProgressStatus.Error && (
            <PriorityHighIcon
              className={classes.twoFaIconError}
              style={{ color: getColor(status) }}
            />
          )}
          <MuiCircularProgress
            variant={status === TwoFaMobileProgressStatus.Pending ? 'indeterminate' : 'determinate'}
            size={80}
            className={classes.twoFaProgress}
            style={{ color: getColor(status) }}
            value={100}
          />
        </Box>
      </Box>
      <Box className={classes.twoFaProgressWrapper}>
        <Typography style={{ color: getColor(status) }}>{getMessage(t, status)}</Typography>
      </Box>
    </>
  )
}
